import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ShareList;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { IconCoursesLine, IconTrashLine, IconResetLine } from '@instructure/ui-icons';
import { Grid } from '@instructure/ui-grid';
import { Avatar } from '@instructure/ui-avatar';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { CAN_EDIT, READ_ONLY, REMOVED_ACCESS, SHARED_WITH_COURSE, SimpleSelect, withStyleOverrides } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
import { ContextualIconButton } from '../ContextualIconButton';
import generateStyle from './styles';
export var ShareList = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_ShareList = /*#__PURE__*/function (_Component) {
  function ShareList() {
    var _this;
    _classCallCheck(this, ShareList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ShareList, [].concat(args));
    _defineProperty(_this, "handlePermissionChange", function (entity) {
      return function (e, _ref) {
        var value = _ref.value;
        _this.props.onPermissionChange(entity, value);
      };
    });
    _defineProperty(_this, "handleEntityRemove", function (e, _ref2) {
      var entity = _ref2.entity,
        isEntityRemoved = _ref2.isEntityRemoved;
      _this.props.onEntityRemove(entity, isEntityRemoved);
    });
    _defineProperty(_this, "renderRemoveButton", function (entity, isEntityRemoved) {
      var context = {
        entity: entity,
        isEntityRemoved: isEntityRemoved
      };
      return jsx(ContextualIconButton, {
        context: context,
        "data-automation": "sdk-unshare-bank-entity-".concat(entity.get('entityId')),
        onClick: _this.handleEntityRemove,
        renderIcon: isEntityRemoved ? IconResetLine : IconTrashLine,
        screenReaderLabel: isEntityRemoved ? t('Undo remove for {entity}', {
          entity: entity.get('title')
        }) : t('Remove {entity}', {
          entity: entity.get('title')
        })
      });
    });
    _defineProperty(_this, "renderEntity", function (entity) {
      var isEntityRemoved = entity.get('permission') === REMOVED_ACCESS;
      var isCourse = entity.get('entityType') === SHARED_WITH_COURSE;
      var originalEntity = _this.props.sharedBanks.find(function (sb) {
        return sb.get('id') == entity.get('id');
      }) || Map();
      var originalPermission = originalEntity.get('permission', READ_ONLY);
      return jsx(Grid.Row, {
        key: entity.get('entityId'),
        "data-automation": "sdk-shared-with-entity-row"
      }, jsx(Grid.Col, {
        width: "small"
      }, isCourse ? jsx(IconCoursesLine, {
        size: "small"
      }) : jsx(Avatar, {
        name: entity.get('title'),
        src: entity.get('avatar'),
        size: "small"
      })), jsx(Grid.Col, null, jsx("span", {
        css: isEntityRemoved ? _this.props.styles.labelRemoved : null,
        "data-automation": isEntityRemoved ? 'sdk-shared-entity-removed' : null
      }, entity.get('title'))), jsx(Grid.Col, {
        width: "auto"
      }, jsx(SimpleSelect, {
        onChange: _this.handlePermissionChange(entity),
        value: entity.get('permission') === REMOVED_ACCESS ? originalPermission : entity.get('permission'),
        renderLabel: jsx(ScreenReaderContent, null, t('Access for {entity}', {
          entity: entity.get('title')
        })),
        disabled: isEntityRemoved || !_this.props.canEdit
      }, jsx(SimpleSelect.Option, {
        id: "share-list-select-option-can-view",
        value: READ_ONLY
      }, t('Can view')), jsx(SimpleSelect.Option, {
        id: "share-list-select-option-can-edit",
        value: CAN_EDIT
      }, t('Can edit')))), jsx(Grid.Col, {
        width: "auto"
      }, _this.props.canEdit && _this.renderRemoveButton(entity, isEntityRemoved)));
    });
    return _this;
  }
  _inherits(ShareList, _Component);
  return _createClass(ShareList, [{
    key: "render",
    value: function render() {
      return jsx(Grid, {
        vAlign: "middle"
      }, this.props.entities.map(this.renderEntity));
    }
  }]);
}(Component), _defineProperty(_ShareList, "displayName", 'ShareList'), _defineProperty(_ShareList, "componentId", "Quizzes".concat(_ShareList.displayName)), _defineProperty(_ShareList, "propTypes", {
  canEdit: PropTypes.bool.isRequired,
  entities: ImmutablePropTypes.listOf(ImmutablePropTypes.contains({
    entityType: PropTypes.string.isRequired,
    entityId: PropTypes.string.isRequired,
    permission: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })).isRequired,
  onPermissionChange: PropTypes.func.isRequired,
  onEntityRemove: PropTypes.func.isRequired,
  sharedBanks: ImmutablePropTypes.list,
  styles: PropTypes.object
}), _ShareList)) || _class);
export default ShareList;